import styled from '@emotion/styled'

export const StyleColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`

export const StyleScreenWrapper = styled.div<any>`
  background: #f0f0f0;
  height: 60vh;
  border-radius: 12px;
  position: relative;
`

export const StyleActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyleActionBg = styled.div`
  background: ${(props: any) => props.theme.colors.secondary150};
  padding: 10px 15px;
  border-radius: 8px;
  display: flex;
  column-gap: 20px;
`

export const StyleLargeScreenWrapper = styled.div`
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
  video {
    border-radius: 8px;
  }
`

export const StyleBeforeAnswerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0px;
  height: 100%;
  align-items: center;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 12px;
`
export const StyleBeforeAnswerColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  align-items: center;
`

export const StyleBeforeAnswerImageWrapper = styled.div`
  img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
  }
`

export const StyleAfterAnswerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0px;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 12px;
`

export const StyleAfterAnswerColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  row-gap: 10px;
`

export const StyleAfterAnswerSenderScreen = styled.div`
  width: 200px;
  height: 150px;
  border-radius: 8px;
  position: absolute;
  right: 20px;
  bottom: 30px;
  background: #f0f0f0;
  video {
    border-radius: 8px;
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`
